export const HeaderStyle = {
  baseStyle: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexShrink: 0,
    width: 'full',
    minWidth: 0,
    height: '4.5rem',
    backgroundColor: 'bg.default',
    borderBottom: '2px solid var(--chakra-colors-border-default)',
  },
}

export const useHeaderStyle = () => {
  return HeaderStyle.baseStyle
}
